const $ = require('jquery');
import dosingCalc from './dosing-calc';
import Cookier from '../classes/cookier.class';

export default function len4prep() {
  // Entry modal
  const hcpCookie = new Cookier('l4p_hcp_confirmed');
  const $entryModal = $('.js-l4p-entry-modal');
  const $entryModalConfirmBtn = $('.js-l4p-entry-modal-btn');

  $entryModalConfirmBtn.on('click', function (e) {
    e.preventDefault();
    hcpCookie.set('true', 1); // 1 day
    $entryModal.addClass('is-hidden');
  });

  // Pre-populate L4P product
  $('select[name=Product][multiple]').val('YEZTUGO').trigger('change');

  // Dosing calculator
  const dosingControl = dosingCalc();

  // Toggle Tabs
  const activateTab = (tab) => {
    $('.js-l4p-tabs-btn, .js-l4p-tabs-content').each(function () {
      const isMatch = $(this).data('tab') === tab;

      $(this).toggleClass('is-active', isMatch);

      if ($(this).hasClass('js-l4p-tabs-btn')) {
        $(this).toggleClass('is-disabled', !isMatch);
      }
    });
  };

  const deactivateAllTabs = () => {
    $('.js-l4p-tabs-btn, .js-l4p-tabs-content').removeClass('is-active is-disabled');
    $('.js-l4p-isi').removeClass('is-collapsed');
  };

  const handleTabUI = (tab) => {
    const $isi = $('.js-l4p-isi');
    const $tabsWrap = $(`.js-l4p-tabs-btn[data-tab="${tab}"]`).closest('.js-tabs');
    const $innerTabs = $tabsWrap.find('.js-tabs');
    const $tabsContent = $('.js-l4p-tabs-content.is-active');
    const $activeTabBtn = $(`.js-l4p-tabs-btn.is-active[data-tab="${tab}"]:visible`);

    // Toggle ISI
    if (!$tabsWrap.find('.js-l4p-tabs-btn.is-active').length) {
      $isi.removeClass('is-collapsed');
    } else {
      $isi.addClass('is-collapsed');
    }

    // Scroll to content
    const $scrollTarget = ($(window).width() >= 1024)
      ? $tabsContent
      : $activeTabBtn;

    if ($scrollTarget.length && !window.location.hash) {
      $('html, body').animate({
        scrollTop: $scrollTarget.offset().top - $('.js-header').outerHeight(),
      }, 500);
    }

    // Reset accordions and inner tabs
    $('.js-accordion-btn.is-active').removeClass('is-active');
    $('.js-accordion-content:visible').hide();
    $innerTabs.find('.js-tabs-panel.is-active, .js-tabs-btn.is-active').removeClass('is-active');
    $innerTabs.find('.js-tabs-panel:first-child, .js-tabs-btn:first-child').addClass('is-active');
    $('.js-tabs-additional-content').hide().first().show();

    dosingControl.reset();
  };

  const initTabFromURL = () => {
    const pathParts = location.pathname.replace(/\/$/, '').split('/');
    const tab = pathParts[2];

    if (tab) {
      activateTab(tab);
      handleTabUI(tab);
    } else {
      deactivateAllTabs();
    }
  };

  const openAccordionFromHash = (subAnchor = null) => {
    const hash = window.location.hash.replace('#', '');

    if (!hash) return;

    const $accordion = $(`#${hash}`);

    if ($accordion.length) {
      const $btn = $accordion.find('.js-accordion-btn');
      const $content = $accordion.find('.js-accordion-content');

      if (!$btn.hasClass('is-active')) {
        $btn.addClass('is-active');
        $content.show();
      }

      setTimeout(() => {
        const offsetTop = subAnchor ? $(`#${subAnchor}`).offset().top : $accordion.offset().top;

        $('html, body').animate({
          scrollTop: offsetTop - $('.js-header').outerHeight(),
        }, 500);
      }, 100);

      $('.js-to-top-btn').attr('href', `#${hash}`);
    }
  };

  // Activate the tab on page load
  initTabFromURL();
  openAccordionFromHash();

  // Back/Forward buttons
  window.addEventListener('popstate', () => {
    initTabFromURL();
    openAccordionFromHash();
  });

  // Toggle ISI
  $('.js-l4p-isi-toggle-btn').on('click', function (e) {
    e.preventDefault();

    $('.js-l4p-isi').toggleClass('is-collapsed');
  });

  // Tabs
  $(document).on('click', '.js-l4p-tabs-btn', function () {
    const tab = $(this).data('tab');

    if ($(this).hasClass('is-active')) {
      history.pushState({ tab }, '', `/len4prep/${tab}/`);

      handleTabUI(tab);
    } else {
      history.pushState(null, '', '/len4prep/');

      deactivateAllTabs();
      $('.js-to-top-btn').attr('href', '#top');
    }
  });

  // Mobile tabs
  $(document).on('click', '.js-tabs-btn', function () {
    const $tabsWrap = $(this).closest('.js-tabs');
    const text = $(this).text();

    $tabsWrap
      .find('.js-tabs-title')
      .not($tabsWrap.find('.js-tabs .js-tabs-title'))
      .text(text);

    $tabsWrap
      .find(
        '.js-toggle-btn[data-target="tabs-buttons"], .js-toggle-target[data-target="tabs-buttons"]'
      )
      .removeClass('is-active');
  });

  // Accordion
  $('.js-accordion-btn').on('click', function () {
    const $accordion = $(this).closest('.js-accordion-item');
    const $innerTabs = $accordion.find('.js-tabs');
    const accordionId = $accordion.attr('id');
    const isActive = $(this).hasClass('is-active');
    const $firstActiveAccordion = $(this).closest('.js-l4p-tabs-content').find('.js-accordion-item').has('.js-accordion-btn.is-active').first();

    if ( $firstActiveAccordion.length ) {
      $('.js-to-top-btn').attr('href', `#${$firstActiveAccordion.attr('id')}`);
    } else {
      $('.js-to-top-btn').attr('href', '#top');
    }

    if (accordionId) {
      const baseUrl = window.location.pathname;

      if (isActive) {
        history.pushState(null, '', `${baseUrl}#${accordionId}`);

        setTimeout(() => {
          $('html, body').animate({
            scrollTop: $accordion.offset().top - $('.js-header').outerHeight(),
          }, 500);
        }, 100);
      } else {
        history.pushState(null, '', baseUrl);
        setTimeout(() => {
          $innerTabs.find('.js-tabs-btn, .js-tabs-panel').removeClass('is-active');
          $innerTabs.find('.js-tabs-btn').first().addClass('is-active');
          $innerTabs.find('.js-tabs-panel').first().addClass('is-active');

          const activeTab = $innerTabs.find('.js-tabs-btn.is-active').data('tab');

          $('.js-tabs-additional-content').hide();
          $(`.js-tabs-additional-content[data-tab="${activeTab}"]`).show();
        }, 500);
      }
    }
  });

  // SPA Links
  $(document).on('click', '.js-spa-link', function (e) {
    e.preventDefault();

    const href = $(this).attr('href');
    const subAnchor = $(this).data('sub-anchor');

    if (!href) return;

    history.pushState(null, '', href);
    initTabFromURL();
    openAccordionFromHash(subAnchor);

    if ( href === '/len4prep' || href === '/len4prep/') {
      setTimeout(() => {
        $('html, body').animate({
          scrollTop: 0,
        }, 500);
      }, 100);

      $('.js-to-top-btn').attr('href', '#top');
    }
  });

  // Tabs additional content
  $('.js-tabs-btn').on('click', function () {
    const tab = $(this).data('tab');

    $(`.js-tabs-additional-content[data-tab="${tab}"]`).show();
    $(`.js-tabs-additional-content[data-tab="${tab}"]`).siblings('.js-tabs-additional-content').hide();
  });
}




// WEBPACK FOOTER //
// ./src/assets/js/project/len4prep.js